import React, { useState,useEffect } from 'react';
import axios from 'axios';

import {Configs} from '../api';
const AddInput =()=> {
    

const [name, setname] = useState('')
const [name1, setname1] = useState('')

const adddata = async (e)=>{
  e.preventDefault();
  try {
  const result = await axios.post(Configs.businesshours,{
    datetimein : name,datetimeout: name1})
  console.log(result);
  window.location.reload();
}
  catch (error) {
    console.log(error.message);
}
}

useEffect(() => {
  const dataID = async() =>{

    try {
    const result = await axios.get(Configs.businesshours)
      setname(result.data.businesshours[0].datetimein)
      setname1(result.data.businesshours[0].datetimeout)
      
    // console.log(result.data.businesshours[0])
  }
    catch (error) {
      console.log(error.message);
  }
  }
  dataID();
}, [])
           return ( 

<div className="container-fluid" >
    <h1 className="text-center mt-5">Business Hours</h1>
      <form className="d-flex mt-5 mb-3 algnItm" onSubmit={adddata}>
        
      <label>Time In    </label>
          <input type='text' 
          className="form-control input-styl1"
          value={name}
          onChange={e=> setname(e.target.value)}
          placeholder="Time In 00:00:AM/PM"
        >
           </input>
         <label>Time Out</label>
           <input type='text' 
          className="form-control input-styl"
          value={name1}
          onChange={e=> setname1(e.target.value)}
          placeholder="Time Out 00:00:AM/PM"
        >
           </input>
          <button className="btn btn-success">add</button>


      </form>
    </div>
         );
    }

 
export default AddInput;
